import { 
  FETCH_CART_REQUEST,
  FETCH_CART_SUCCESS,
  FETCH_CART_FAILURE,
  CLEAR_CART, 
  PLACE_ORDER,
  UPDATE_QUANTITY_REQUEST,
  ADD_TO_CART_REQUEST,
  PLACE_ORDER_NOW_REQUEST,
  PLACE_ORDER_CART_REQUEST,
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  FETCH_ORDER_FAILURE,
  FETCH_ORDERS_LIST_REQUEST,
  FETCH_ORDERS_LIST_SUCCESS,
  FETCH_ORDERS_LIST_FAILURE,
  FETCH_CART_COUNT_SUCCESS
} from './actionTypes';

const loadState = (key, defaultVal) => {
  try {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : defaultVal;
  } catch (e) {
    return defaultVal;
  }
};

const saveState = (key, state) => {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch (e) {
    // Ignore write errors
  }
};

const initialState = {
  cart: {
    items: [],
    totalQty: 0,
    total: 0,
    currency: 'CNY',
    loading: false,
    error: null,
  },
  orders: loadState('esi-redux-orders', []), // Legacy
  orderInfo: {
    data: null,
    loading: false,
    error: null
  },
  orderList: {
    data: [],
    total: 0,
    loading: false,
    error: null
  }
};

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CART_REQUEST:
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        cart: { ...state.cart, loading: true, error: null }
      };

    case FETCH_CART_SUCCESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          _id: action.payload._id || action.payload.id,
          items: action.payload.items || [],
          totalQty: action.payload.totalQty || 0,
          total: action.payload.total || 0,
          currency: action.payload.currency || 'CNY'
        }
      };
    case FETCH_CART_COUNT_SUCCESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          totalQty: action.payload || 0,
        }
      };

    case FETCH_CART_FAILURE:
      return {
        ...state,
        cart: { ...state.cart, loading: false, error: action.payload }
      };

    case UPDATE_QUANTITY_REQUEST: {
      const { itemId, qty } = action.payload;
      const newItems = state.cart.items.map(item => 
        item._id === itemId ? { ...item, qty } : item
      );
      const newTotal = newItems.reduce((sum, item) => sum + (item.qty * (item.unitPrice || item.price || 0)), 0);
      const newTotalQty = newItems.reduce((sum, item) => sum + item.qty, 0);

      return {
        ...state,
        cart: {
          ...state.cart,
          items: newItems,
          total: newTotal,
          totalQty: newTotalQty
        }
      };
    }

    case CLEAR_CART: {
      return { 
        ...state, 
        cart: { ...initialState.cart } 
      };
    }

    case PLACE_ORDER: {
      const newState = {
        ...state,
        orders: [action.payload, ...state.orders],
        cart: { ...initialState.cart }
      };
      saveState('esi-redux-orders', newState.orders);
      return newState;
    }

    case PLACE_ORDER_NOW_REQUEST:
    case PLACE_ORDER_CART_REQUEST:
    case FETCH_ORDER_REQUEST:
      return {
        ...state,
        orderInfo: { ...state.orderInfo, loading: true, error: null }
      };

    case FETCH_ORDER_SUCCESS:
      return {
        ...state,
        orderInfo: { data: action.payload, loading: false, error: null }
      };
      
    case FETCH_ORDER_FAILURE:
      return {
        ...state,
        orderInfo: { ...state.orderInfo, loading: false, error: action.payload }
      };

    case FETCH_ORDERS_LIST_REQUEST:
      return {
        ...state,
        orderList: { ...state.orderList, loading: true, error: null }
      };

    case FETCH_ORDERS_LIST_SUCCESS:
      return {
        ...state,
        orderList: { 
          data: action.payload.data || action.payload.items || action.payload, 
          total: action.payload.total || action.payload.totalCount || 0,
          loading: false, 
          error: null 
        }
      };
      
    case FETCH_ORDERS_LIST_FAILURE:
      return {
        ...state,
        orderList: { ...state.orderList, loading: false, error: action.payload }
      };

    default:
      return state;
  }
};

export default shopReducer;
